export const REPORT_SUMMARY_COLORS = [
  "#1E61DC",
  "#60A5FA",
  "#93C5FD",
  "#BFDBFE",
  "#3B82F6",
  "#2563EB",
  "#1D4ED8",
  "#1E40AF",
  "#1E3A8A",
  "#172554",
  "#0F172A",
];

export const getDailyRevenue = (flightSummaryData) => {
  const daysOfWeek = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  return (
    flightSummaryData?.data?.totalFlightRevenue?.history?.map((value, index) => ({
      day: daysOfWeek[index],
      revenue: value,
    })) || []
  );
};
